import { render, staticRenderFns } from "./LessonNew.vue?vue&type=template&id=1a3e6124&"
import script from "./LessonNew.vue?vue&type=script&lang=js&"
export * from "./LessonNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports